<!-- =========================================================================================
  File Name: ItemGridView.vue
  Description: Item Component - Grid VIew
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
            <vx-card class="grid-view-item mb-base overflow-hidden" v-on="$listeners">
  
  
                <template slot="no-body">   
                    <div class="item-img-container bg-white  items-center justify-center cursor-pointer">
                      <vs-tooltip :text="item.name">
                       <img :src="item.url" :alt="item.name" class="grid-view-img responsive img-libary" v-bind:class="{ selected_img: item.check }">
                         </vs-tooltip >
                          <vs-checkbox class="middle_img_checkbox flex" @input="SelectItem(item.id)" v-model="item.check" ></vs-checkbox>
                           <div class="middle_img_name flex middle_img_name_text">
                              <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer img-kabab" >
                                <div>
                                <feather-icon icon="MoreVerticalIcon" @click.stop="" svgClasses="w-6 h-6 hover:text-primary stroke-current"/>
                                </div>
                            <vs-dropdown-menu>
                                 <vs-dropdown-item @click="ChangeName(item)">
                            <span class="flex items-center"  >
                                <feather-icon icon="EditIcon" svgClasses="h-2 w-2" class="mr-2 "/>
                                <span>Rename</span>
                            </span>
                             </vs-dropdown-item>
                            <vs-dropdown-item  @click="deleteImg(item.id)">
                            <span class="flex items-center" >
                                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                                <span>Delete</span>
                            </span>
                            </vs-dropdown-item>
                            </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>
                    </div>
                </template>
                <template slot="no-body">
                <vs-popup  title="Rename" :active.sync="RenamePopupActive">
                <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10" >
                    <vs-input v-model="oldImg.newname" class="w-full"></vs-input>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" >
                   <vs-button @click.native="RenameImg(oldImg)">Save</vs-button>
                </vs-col>
               </vs-row>
            </vs-popup>
            </template>
            </vx-card>
           
            
</template>

<script>
import 'viewerjs/dist/viewer.css'
import {
CHANGE_IMG_NAME,
DELETE_IMG_FROM_LIBRARY
} from '@/graphql'
export default{
    components: {

  },

data () {
    return {
    RenamePopupActive:false,
    ImageViewPopup:false,
    oldImg:{},
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    SelectItem(id){
      this.$emit('selectItem',id)
    },
    deleteImg(id){
      this.$apollo
        .mutate({
          mutation: DELETE_IMG_FROM_LIBRARY,
          variables: {
                id: id,
          }
        })
        .then(response => {
            if(response.data.deleteImgFromLibrary.status==='Success'){
                this.$emit('getdata','image')
            }
            else{
                this.$vs.notify({
                title: 'Images',
                text:response.data.deleteImgFromLibrary.message,
                color: 'danger',
                position: 'top-right'
              })
            }
        }
        )
    },
    ChangeName(img){
     this.oldImg=img
     var ex=this.oldImg.name.split(".").pop();
     this.oldImg.ext='.'+ex
     this.oldImg.newname=this.oldImg.name.replace('.'+ex,'')
     this.RenamePopupActive=true
    },
    RenameImg(img){
    if(img.id){
        this.RenamePopupActive=false
         this.oldImg.name=img.newname+img.ext
         this.$apollo
        .mutate({
          mutation: CHANGE_IMG_NAME,
          variables: {
                name: img.newname+img.ext,
                id: img.id,
          }
        })
        .then(response => {
             this.oldImg={}
             this.$emit('getdata','image')
        }
        )
    }
    },

  }
}
</script>

<style lang="scss" scoped>
.grid-view-item {
    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
